import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const VendorGroupApiResources = {
  list:  createUrl('vendor-groups'),
  create:  createUrl('vendor-groups/create'),
  detail:  createUrl('vendor-groups'),
  update:  createUrl('vendor-groups'),
};
